import { useState } from 'react'

import { Box, Text, useUnsafeEffect } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import { dispatch } from 'modules/core/lib/pubSub'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { REFETCH_DATA_EVENT } from 'modules/finance/components/FinancialWorkspace/components/Table/const'
import { UploadPayrollButton } from 'modules/finance/components/FinancialWorkspace/components/UploadPayroll'
import { FinancialWorkspaceAvailabilities } from 'modules/finance/components/FinancialWorkspace/hooks/useFinancialWorkspaceAvailabilities'

import { Banner, localStorageKey } from './LaunchBanner'

const SOURCE = 'fw-payroll-header'

interface Props {
  availabilities: FinancialWorkspaceAvailabilities
}

export const Header = ({ availabilities }: Props) => {
  const [date] = useLocalStorage<Date>(`factorial:${localStorageKey}`)
  const [visiblePayrollButton, setVisiblePayrollButton] = useState(
    !!date || availabilities.modules.expenses
  )

  const onFinishPayroll = () => {
    dispatch({ type: REFETCH_DATA_EVENT })
  }

  useUnsafeEffect(() => {
    setVisiblePayrollButton(!!date || availabilities.modules.expenses)
  }, [date, availabilities.modules.expenses])

  const title = i18n.t('finance.financial_workspace.payroll.title')
  return (
    <Box gap="s12">
      <Box flexDirection="row" gap="s24" justifyContent="flexEnd">
        <Box flexDirection="column">
          {visiblePayrollButton && (
            <UploadPayrollButton
              type="default"
              includeButtonIcon
              source={SOURCE}
              onFinish={onFinishPayroll}
              version="factorial-one"
            />
          )}
        </Box>
      </Box>
      <Banner
        onRestore={() => setVisiblePayrollButton(false)}
        onClose={() => setVisiblePayrollButton(true)}
      />
    </Box>
  )
}
